import {
    Component,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import * as fromShared from '../../../shared';
import * as fromDataServices from '../../../data-services';
import { ReplaySubject } from 'rxjs';
import { SelectItem } from '../../../shared';
import moment from 'moment';
import * as env from '../../../../environments/environment';
import { DisplayErrors } from '../../../shared/errors-sidenav';

@Component({
    selector: 'ef-send-invoice-presenter',
    templateUrl: './send-invoice-presenter.component.html',
    styleUrls: ['./send-invoice-presenter.component.scss'],
    standalone: false
})
export class SendInvoicePresenter
    extends DisplayErrors<fromDataServices.Invoice.InvoiceModel>
    implements OnInit, OnChanges
{
    moment: any;
    environment = env.environment;
    @Input() public items: fromDataServices.Invoice.InvoiceModel[] = [];
    @Output() public SendInvoices = new ReplaySubject<
        fromDataServices.Invoice.InvoiceModel[]
    >(1);
    public selectedInvoices: any[];
    numCols = 8;
    constructor() {
        super();
        this.moment = moment;
    }
    ngOnInit(): void {
        this.SendInvoices.subscribe(items => {
            this.selectedInvoices = [];
        });
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
    }
}
